import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const faqs = [
  {
    q: "Adakah semakan ini dikenakan bayaran?",
    a: "Tidak. Semakan awal kelayakan adalah 100% percuma dan tanpa sebarang komitmen. Anda hanya perlu menghubungi kami melalui WhatsApp.",
  },
  {
    q: "Berapa jumlah pembiayaan yang boleh saya mohon?",
    a: "Antara RM3,000 hingga RM100,000, tertakluk pada penilaian kelayakan dan profil kewangan anda.",
  },
  {
    q: "Berapa lama proses semakan mengambil masa?",
    a: "Maklum balas awal biasanya diberikan dalam masa 24–48 jam bekerja. Sebarang kelulusan akhir adalah tertakluk pada penilaian pihak pembiaya yang berkenaan.",
  },
  {
    q: "Adakah saya perlu membayar deposit atau yuran pendahuluan?",
    a: "Tidak. Kami tidak mengenakan sebarang bayaran pendahuluan. Berhati-hati dengan mana-mana pihak yang meminta bayaran sebelum perkhidmatan diberikan.",
  },
];

export const Faq = () => (
  <section data-testid="faq-section" className="bg-white py-20 sm:py-28">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-sm text-gold-dark uppercase tracking-widest font-semibold">
          Soalan Lazim
        </p>
        <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-navy">
          Soalan Yang Sering Ditanya
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion
          type="single"
          collapsible
          data-testid="faq-accordion"
          className="mt-10 space-y-3"
        >
          {faqs.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-navy/10 bg-[#F8F9FA] px-6 transition-colors duration-200 data-[state=open]:border-gold/50 data-[state=open]:bg-white"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-heading text-base sm:text-lg font-semibold text-navy hover:no-underline hover:text-gold-dark transition-colors duration-200"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="pb-5 text-sm sm:text-base text-slate-600 leading-relaxed"
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
